import React from 'react';
import AvatarWithAction from '../components/AvatarWithAction';
import MetaList, { MetaListItem } from '../components/MetaList';
import Timestamp from '../components/Timestamp';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import * as styles from './Activity.module.scss';

const ACTIVITY_ACTOR_FRAGMENT = gql(`
  fragment Activity_actor on User {
    id
    ...AvatarWithAction_user
  }
`);

interface ActivityProps {
  actor: DocumentType<typeof ACTIVITY_ACTOR_FRAGMENT>;
  action:
    | 'POST_EDIT'
    | 'COMMENT_CREATE'
    | 'COMMENT_REPLY'
    | 'POST_THANK'
    | 'POST_PUBLISH'
    | 'INVITE_ACCEPT';
  actedAt: number | string;
  title: React.ReactNode;
  meta?: string | null;
  metaRight?: React.ReactNode;
  children?: React.ReactNode;
}

const Activity = ({
  actor,
  action,
  actedAt,
  title,
  meta,
  metaRight,
  children,
}: ActivityProps) => (
  <article className={styles.activity}>
    <aside className={styles.timeline}>
      <AvatarWithAction user={actor} action={action} />
      <div className={styles.line} />
    </aside>
    <main className={styles.content}>
      <div role="heading" aria-level={5} className={styles.title}>
        {title}
      </div>
      {!!children && (
        <article className={styles.contentWrapper}>{children}</article>
      )}
      <footer className={styles.meta}>
        <MetaList>
          <MetaListItem>
            <div className={styles.timestamp}>
              <Timestamp date={actedAt} />
            </div>
          </MetaListItem>
          {meta && <MetaListItem>{meta}</MetaListItem>}
        </MetaList>
        {!!metaRight && <div className={styles.metaRight}>{metaRight}</div>}
      </footer>
    </main>
  </article>
);

export default Activity;
